module.exports = __webpack_public_path__ + "band_13.90bd84fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_13.png
// module id = flg2
// module chunks = 0